import Repository from '@/repositories/RepositoryFactory';
import ENUM from '../../enums/APISTATE';
import store from '../';
import moment from 'moment';
import { uuid } from 'vue-uuid';

const AppUsersRepository = Repository.get('appUsers');

export default {
  namespaced: true,
  state: {
    apiState: ENUM.INIT,
    appUser: {},
    appUsers: [],
    myAppUser: {},
    employments: [],
    role: ""
  },
  mutations: {
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setAppUser(state, appUserResponse) {
      const { data } = appUserResponse;
      if ( data && data.employments ) {
        data.employments.forEach( e => {
          e.fromDate = new Date( e.fromDate );
          e.toDate = e.toDate ? new Date( e.toDate ) : null;
          e.isEditing = false;
        } );
      }
      state.employments = data.employments;
      state.role = data.role;
      state.appUser = data;
      state.apiState = ENUM.LOADED;
    },
    addEmptyEmployment(state){
      if(!state.appUser.employments){
        state.appUser.employments = [];
      }
      if(state.appUser.employments.length !== 0 && state.appUser.employments[state.appUser.employments.length - 1].isEditing){
        return;
      }
      state.appUser.employments.push({
        appUserId: state.appUser.id ?? "",
        fromDate: new Date(),
        toDate: null,
        role: state.appUser.role ?? "Replacement",
        isNew: true,
        isEditing: true,
        index: state.appUser.employments.length
      });
      state.employments = state.appUser.employments;
    },
    saveEmployment(state, employment){
      employment.isEditing = false;
      state.appUser.employments[employment.index] = employment;
      state.employments[ employment.index ] = employment;
      const today = new Date();
      if ( state.appUser.employments.length === 1 )
      {
        state.role = employment.role;
      }
      else if ( employment.fromDate >= today && ( employment.toDate ? employment.toDate < today : true ) )
      {
        state.appUser.role = employment.role;
      }
    },
    setRole ( state, role ) {
      state.role = role;
    },
    setEditEmployment(state, employment){
      const index = state.employments.findIndex( e => e.toDate == employment.toDate 
                                          && e.fromDate === employment.fromDate 
                                          && e.role === employment.role);
      state.employments[ index ].isEditing = true;
      state.employments[ index ].index = index;
    },
    removeEmployment(state, employmentIndex){
      state.appUser.employments.splice(employmentIndex, 1);
      state.employments.splice( employmentIndex, 1 );
    },
    setAppUsers(state, appUsersResponse) {
      const { data } = appUsersResponse;
      state.appUsers = data;
      state.apiState = ENUM.LOADED;
    },
    setMyAppUser(state, appUserResponse) {
      const { data } = appUserResponse;
      state.myAppUser = data;
      state.apiState = ENUM.LOADED;
    }
  },
  actions: {
    async loadAppUser({ commit }, appUserId) {
      commit('setApiState', ENUM.LOADING);
      try {
        if ( appUserId !== null )
        {
          let appUser  = await AppUsersRepository.getOne(appUserId);
          appUser.data.startDate = moment(appUser.data.startDate).toDate();
          appUser.data.endDate = moment(appUser.data.endDate).toDate();
          commit( "setRole", appUser.role );
          commit( 'setAppUser', appUser ); 
        }
        else {
          commit('setAppUser', {data: {}});
        }
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async setEmptyAppUser ( { commit } ) {
      commit( 'setAppUser', { data: { id: uuid.v1(), role: 'User', employments: [] } } );
    },
    async addEmptyEmployment({commit}){
      commit("addEmptyEmployment")
    },
    async editEmployment({commit}, employment){
      commit("setEditEmployment",employment);
    },
    async removeEmployment({commit,state}, employment){
      const employmentIndex = state.appUser.employments.indexOf(employment);
      commit("removeEmployment", employmentIndex);
    },
    async saveEmployment({commit}, employment){
      commit("saveEmployment", employment);
    },
    async loadAppUsers({ commit }) {
      commit('setApiState', ENUM.LOADING);
      try {
        commit('setAppUsers', await AppUsersRepository.getAll());
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async registerAppUser ( { commit, dispatch, state }, appUserDto ) {
      commit('setApiState', ENUM.LOADING);
      try {
        appUserDto.employments = state.employments;
        appUserDto.role = state.role;
        await AppUsersRepository.registerAppUser(appUserDto);
        await dispatch('loadAppUsers');
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async updateAppUser({ commit, dispatch, state }, appUserDto) {
      commit('setApiState', ENUM.LOADING);
      try {
        appUserDto.employments = state.employments;
        appUserDto.employments.forEach(e => {
          const fromDate = moment(e.fromDate).toDate();
          e.fromDate = new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes(),fromDate.getSeconds()));
          if(e.toDate){
            const toDate = moment(e.toDate).toDate();
            e.toDate = new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes(),toDate.getSeconds()));
          }
        } );
        appUserDto.role = state.role;
        await AppUsersRepository.updateAppUser(appUserDto);
        await dispatch('loadAppUsers');
        if (appUserDto.id === state.appUser?.id) {
          await dispatch('loadAppUser', appUserDto.id);
        }
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async setAppUserPassword({ commit }, { id, form }) {
      commit('setApiState', ENUM.LOADING);
      try {
        await AppUsersRepository.setAppUserPassword(id, form);
        commit('setApiState', ENUM.LOADED);
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async loadMyUser({ commit }) {
      commit('setApiState', ENUM.LOADING);
      try {
        const oidcUser = store?.getters['oidcStore/oidcUser'];
        commit('setMyAppUser', await AppUsersRepository.getOne(oidcUser?.sub));
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async deleteAppUser({ commit }, id) {
      commit('setApiState', ENUM.LOADING);

      try {
        await AppUsersRepository.deleteUser(id);
        commit("setApiState", ENUM.LOADED);
      } catch(err) {
        console.error(err);
        commit("setApiState", ENUM.ERROR);
      }
    }
  },
  getters: {
    appUserApiState(state) {
      return state.apiState;
    },
    appUser(state) {
      return state.appUser;
    },
    employments ( state ) {
      return state.employments;
    },
    userRole ( state ) {
      return state.role ?? "Ukendt";
    },
    appUsers(state) {
      return state.appUsers;
    },
    myAppUser(state) {
      return state.myAppUser;
    }
  }
}